import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectButtonOptionClickEvent } from 'primeng/selectbutton';
import { SliderChangeEvent } from 'primeng/slider';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { LabelCode } from '@app/shared/interfaces/label-code.interface';
import { FinancialData } from '@app/shared/interfaces/data/financial-data.interface';

@Component({
    selector: 'app-financial-simulator-mobile',
    standalone: true,
    imports: [CommonModule, SharedModule, TranslateModule],
    templateUrl: './financial-simulator-mobile.component.html',
    styleUrl: './financial-simulator-mobile.component.scss',
})
export class FinancialSimulatorMobileComponent implements OnInit {
    @Input() brand = '';
    @Input() model = '';
    @Input() data!: FinancialData;
    @Input() isPortraitDevice = false;
    @Input() isOpenFinancialSimulator = false;


    @Output() isOpenedFinancialCart = new EventEmitter<boolean>();


    //isOpenFinancialSimulator: Boolean = false;

    installmentMonthlyGrossAmount = 'core.components.financialCart.financialSimulator.installmentMonthlyGrossAmount';
    downPaymentGrossAmount = 'core.components.financialCart.financialSimulator.downPaymentGrossAmount';
    duration = 'core.components.financialCart.financialSimulator.duration';

    nominalRate = 'core.components.financialCart.financialSimulator.nominalRate';
    aprcRate = 'core.components.financialCart.financialSimulator.aprcRate';
    amountFinanced = 'core.components.financialCart.financialSimulator.amountFinanced';
    totalInterestGrossAmount = 'core.components.financialCart.financialSimulator.totalInterestGrossAmount';
    totalCreditCost = 'core.components.financialCart.financialSimulator.totalCreditCost';
    totalAmountDue = 'core.components.financialCart.financialSimulator.totalAmountDue';
    installmentTotalGrossAmount = 'core.components.financialCart.financialSimulator.installmentTotalGrossAmount';

    installmentFirstGrossAmount = 'core.components.financialCart.financialSimulator.installmentFirstGrossAmount';
    installmentLastGrossAmount = 'core.components.financialCart.financialSimulator.installmentLastGrossAmount';

    modifyConditionsFinancing = 'core.components.financialCart.financialSimulator.modifyConditionsFinancing';
    multiOptionCreditConditions = 'core.components.financialCart.financialSimulator.multiOptionCreditConditions';
    classicCreditConditions = 'core.components.financialCart.financialSimulator.classicCreditConditions';
    creditDuration = 'core.components.financialCart.financialSimulator.creditDuration';
    annualMileage = 'core.components.financialCart.financialSimulator.annualMileage';
    formalisationCommission = 'core.components.financialCart.financialSimulator.formalisationCommission';
    paymentProtectionInsurance = 'core.components.financialCart.financialSimulator.paymentProtectionInsurance';

    legalText1 = 'core.components.financialCart.financialSimulator.legalText1';
    legalText2 = 'core.components.financialCart.financialSimulator.legalText2';
    legalText3 = 'core.components.financialCart.financialSimulator.legalText3';
    legalText4 = 'core.components.financialCart.financialSimulator.legalText4';
    legalText5 = 'core.components.financialCart.financialSimulator.legalText5';
    legalText6 = 'core.components.financialCart.financialSimulator.legalText6';

    calculateButton = 'common.buttons.calculateButton';
    cancelButton = 'common.buttons.cancelButton';

    moreInformationButton = 'common.buttons.moreInformationButton';
    lessInformationButton = 'common.buttons.lessInformationButton';

    moreInformationButtonExpanded = false;

    cancelButtonDisabled = false;
    saveButtonDisabled = true;

    periods: LabelCode[] = [];

    financialProductOptions: LabelCode[] = [];

    commissionIncluded: LabelCode[] = [
        { label: 'Incluidos en la financiación', code: 'INC' },
        { label: 'A pagar en la primera cuota', code: 'NINC' },
    ];

    paymentInsurance: LabelCode[] = [
        { label: 'Incluído', code: 'INC' },
        { label: 'No incluído', code: 'NINC' },
    ];

    formGroup!: FormGroup;

    selectedFinancialProduct!: LabelCode;
    selectedCommissionIncluded: LabelCode = { label: 'Incluidos en la financiación', code: 'INC' };
    selectedPaymentInsurance: LabelCode = { label: 'No incluído', code: 'NINC' };

    selectedDuration: any;
    selectedDownPaymentGrossAmount: number = 0;
    selectedAnnualMileage: number = 0;

    durationsRangeMin: number = 0;
    durationsRangeMax: number = 0;
    durationsRangeStep: number = 0;
    durationsRangeDef: number = 0;

    downPaymentGrossAmountRangeMin: number = 0;
    downPaymentGrossAmountRangeMax: number = 0;
    downPaymentGrossAmountRangeStep: number = 0;
    downPaymentGrossAmountRangeDef: number = 0;

    annualMileagesRangeMin: number = 0;
    annualMileagesRangeMax: number = 0;
    annualMileagesRangeStep: number = 0;
    annualMileagesRangeDef: number = 0;

    isMultiCreditSelected: boolean = false;

    today: Date = new Date();

    constructor(private fb: FormBuilder) {}
//
    ngOnInit(): void {
        this.selectedFinancialProduct = {
            label: this.data.financialProduct.name,
            code: this.data.financialProduct.id,
        };

        this.selectedCommissionIncluded = this.commissionIncluded[0];
        this.selectedPaymentInsurance = this.paymentInsurance[1];

        this.selectedDownPaymentGrossAmount = this.data.downPaymentGrossAmount ? this.data.downPaymentGrossAmount : 0;
        this.selectedAnnualMileage = this.data.annualMileages ? this.data.annualMileages : 0;

        this.fillDataFinancialProduct();

        this.createForm();
        this.formIsValid();
    }

    fillDataFinancialProduct(value: any = undefined) {
        if (value != undefined) this.selectedFinancialProduct = value;

        if (this.selectedFinancialProduct.code == 'MCM') this.isMultiCreditSelected = true;
        else this.isMultiCreditSelected = false;

        if (this.data.financialProducts) {
            this.data.financialProducts.forEach((financialProductOption) => {
                let financialProductOptionAux: LabelCode = {
                    code: financialProductOption.id,
                    label: financialProductOption.name,
                };

                if (value == undefined) this.financialProductOptions.push(financialProductOptionAux);

                if (financialProductOption.id == this.selectedFinancialProduct.code) {
                    this.downPaymentGrossAmountRangeMin = financialProductOption.downPaymentGrossAmountRange.minimum;
                    this.downPaymentGrossAmountRangeMax = financialProductOption.downPaymentGrossAmountRange.maximum;
                    this.downPaymentGrossAmountRangeStep = financialProductOption.downPaymentGrossAmountRange.step;
                    this.downPaymentGrossAmountRangeDef = financialProductOption.downPaymentGrossAmountRange.defaultValue;

                    this.durationsRangeMin = financialProductOption.durationsRange.minimum;
                    this.durationsRangeMax = financialProductOption.durationsRange.maximum;
                    this.durationsRangeStep = financialProductOption.durationsRange.step;
                    this.durationsRangeDef = financialProductOption.durationsRange.defaultValue;

                    this.annualMileagesRangeMin = financialProductOption.annualMileagesRange ? financialProductOption.annualMileagesRange.minimum : 0;
                    this.annualMileagesRangeMax = financialProductOption.annualMileagesRange ? financialProductOption.annualMileagesRange.maximum : 0;
                    this.annualMileagesRangeStep = financialProductOption.annualMileagesRange ? financialProductOption.annualMileagesRange.step : 0;
                    this.annualMileagesRangeDef = financialProductOption.annualMileagesRange
                        ? financialProductOption.annualMileagesRange.defaultValue
                        : 0;
                }
            });
        }

        this.periods = [];

        let i = this.durationsRangeMin;
        while (i <= this.durationsRangeMax) {
            let item: LabelCode = {
                label: '' + i.toString() + ' meses',
                code: '' + i.toString() + '',
            };

            this.periods.push(item);
            i += this.durationsRangeStep;
        }

        this.periods.forEach((item) => {
            if (this.data.duration.toString() == item.code) {
                this.selectedDuration = item;
                //this.data.duration = item.code;
            }
        });
    }

    createForm() {
        this.formGroup = this.fb.group({
            typeFinancialProduct: new FormControl(this.selectedFinancialProduct ? this.selectedFinancialProduct.code : this.data.financialProduct.id),
            commissionIncluded: new FormControl(this.selectedCommissionIncluded ? this.selectedCommissionIncluded : 'INC'),
            paymentInsurance: new FormControl(this.selectedPaymentInsurance ? this.selectedPaymentInsurance : 'NINC'),
            duration: new FormControl(this.selectedDuration ? this.selectedDuration : this.durationsRangeDef),
            downPaymentGrossAmount: new FormControl(
                this.selectedDownPaymentGrossAmount ? this.selectedDownPaymentGrossAmount : this.downPaymentGrossAmountRangeDef,
                [Validators.required, Validators.min(this.downPaymentGrossAmountRangeMin), Validators.max(this.downPaymentGrossAmountRangeMax)],
            ),
            downPaymentGrossAmountSlider: new FormControl(
                this.selectedDownPaymentGrossAmount ? this.selectedDownPaymentGrossAmount : this.downPaymentGrossAmountRangeDef,
                [Validators.required, Validators.min(this.downPaymentGrossAmountRangeMin), Validators.max(this.downPaymentGrossAmountRangeMax)],
            ),
            annualMileageSlider: new FormControl(this.selectedAnnualMileage ? this.selectedAnnualMileage : this.annualMileagesRangeDef, [
                Validators.required,
                Validators.min(this.annualMileagesRangeMin),
                Validators.max(this.annualMileagesRangeMax),
            ]),
        });
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    onMoreInformation() {
        this.moreInformationButtonExpanded = !this.moreInformationButtonExpanded;
    }





    onChangeFinancialProduct(event: SelectButtonOptionClickEvent) {
        this.fillDataFinancialProduct(event.option);

        this.createForm();

        //this.formGroup.controls.typeFinancialProduct.setValue(this.selectedFinancialProduct.code);
        this.formIsValid();
    }

    onChangeDurationFinancing(event: DropdownChangeEvent) {
        this.selectedDuration = event.value;
        this.data.duration = this.selectedDuration.code;
        this.formIsValid();
    }

    onChangeDownPaymentGrossAmount(event: Event) {
        this.selectedDownPaymentGrossAmount = Number(this.formGroup.controls.downPaymentGrossAmount.getRawValue());
        this.data.downPaymentGrossAmount = this.selectedDownPaymentGrossAmount;

        this.formGroup.controls.downPaymentGrossAmountSlider.setValue(this.selectedDownPaymentGrossAmount);
        this.formGroup.controls.downPaymentGrossAmount.setValue(this.selectedDownPaymentGrossAmount);
        this.formIsValid();
    }

    onChangeDownPaymentGrossAmountSlider(event: SliderChangeEvent) {
        this.selectedDownPaymentGrossAmount = Number(event.value);
        this.data.downPaymentGrossAmount = this.selectedDownPaymentGrossAmount;

        this.formGroup.controls.downPaymentGrossAmount.setValue(this.selectedDownPaymentGrossAmount);
        this.formIsValid();
    }

    onChangeAnnualMileageSlider(event: SliderChangeEvent) {
        this.selectedAnnualMileage = Number(event.value);

        this.formGroup.controls.annualMileageSlider.setValue(this.selectedAnnualMileage);
        this.formIsValid();
    }

    onChangeCommissionIncluded(event: SelectButtonOptionClickEvent) {
        this.selectedCommissionIncluded = event.option;
        this.formGroup.controls.commissionIncluded.setValue(this.selectedCommissionIncluded.code);
        this.formIsValid();
    }

    onChangePaymentInsurance(event: SelectButtonOptionClickEvent) {
        this.selectedPaymentInsurance = event.option;
        this.formGroup.controls.paymentInsurance.setValue(this.selectedPaymentInsurance.code);
        this.formIsValid();
    }


    //-------------------------//

    onFinancialSimulator(event: boolean) {
        //this.isOpenFinancialSimulator = true;
        this.isOpenedFinancialCart.emit(event);
    }

/*
    onShowFinancialSimulator(event: Event) {
        this.isOpenFinancialSimulator = true;
        this.isOpenedFinancialCart.emit(true);
    }

    onHideFinancialSimulator(event: Event) {
        this.isOpenFinancialSimulator = false;
        this.isOpenedFinancialCart.emit(false);
    }
 */


    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.saveButtonDisabled = !this.formGroup.valid;
    }

    onSubmit(financialSimulatorData: any) {
        this.formGroup.reset();

        console.log('Datos_guardados: ', financialSimulatorData);
    }

    onClicButtonCancel() {
        this.isOpenedFinancialCart.emit(false);
        console.log('Cerramos_el_simulador_movil');
    }
}
